<template>
    <div class="fx fx-c_stretch ">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="main_tabs">
            <el-tab-pane label="帮助文档" name="first" >
            </el-tab-pane>
            <el-tab-pane label="帮助视频" name="second">
            </el-tab-pane>
        </el-tabs>
        <div class="funcs fx-col fx-c_center">
            <el-col :span="12">
                <el-menu
                    :default-active="activeIndex"
                    @open="handleOpen"
                    @close="handleClose"
                    class="el-menu-vertical-demo"
                >
                    <el-menu-item :index="item.id+''"  v-for="(item, i) in tableData" :key="i"  @click="initList(item.id)">
                        <span slot="title">{{item.name}}</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
        </div>
        <div class="fx-g1 edit_panel" v-if="activeName=='first'" key="edit_div1">
            <el-collapse v-model="activeName1" accordion>
                <el-collapse-item   v-for="(item, i) in list" :key="i" >
                    <template slot="title" >
                        <div v-html="item.title" class="title_div"></div>
                    </template>
                    <div v-html="item.content" style="margin-left: 6px;" class="content_div" :key="item.id"></div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="fx-g1 edit_panel" v-if="activeName=='second'">
            <div style="width: 200px;display: flex;">
                <span  v-for="(item, i) in list" :key="i" @click="playVideo(item.content)">
                    <file-preview  :key="i" :allow-preview="true" :allow-download="true"
                                   width="200" height="120" :url="item.content" @play="$emit('play', item.content)"></file-preview>
                    <div v-html="item.title" style="text-align: center;"></div>
                </span>
            </div>
        </div>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>
    </div>
</template>
<style>
.content_div img {
    max-width: 1200px
}
</style>
<style scoped>
    .content_div img {
        max-width: 1200px
    }
    .main_tabs{
        background-color: white;
        position: absolute;
        padding-left: 17px;
        width: 100%;
    }
    .funcs {
        width: 310px;
        background: white;
        box-sizing: border-box;
        padding: 15px;
        padding-top: 45px;
    }
    .func_tree {
        width: 100%;
        margin-top: 15px;
    }
    .edit_panel {
        background: white;
        margin-left: 15px;
        padding: 60px;
    }
    .edit_form {
        width: 70%;
    }
    .custom-tree-node {
        padding: 2px 5px 0;
    }
    .custom-tree-node.active {
        background: #dadada;
    }
    .title_div {
        width:92%;
        padding-left: 25px;
        background-color:#ddd;
        height: 94%;
        margin-left: 5px;
        border-radius: 5px;
        font-size: 18px;
        color: inherit;
        font-weight:bold;
    }
</style>
<script>
    import VideoDrawer from '@/components/VideoDrawer';
    export default {
        components: {
            VideoDrawer
        },
        props: [
            "label",
            "resources",
            "showBox",
        ],
        data() {
            return {
                form:{
                    keywords:""
                },
                tableData: [],
                list: [],
                activeIndex:"",
                activeName:"first",
                type:1,
                activeName1:"",
                showVideo: false,
                currentVideo: null,
            }
        },
        watch: {
            "type": {
                handler: function () {
                    this.loadData();
                },
                deep: true
            },
        },
        computed: {
        },
        methods: {
            handleClick(tab, event) {
                this.tableData = [];
                this.list = [];
                if(tab.name == 'first'){
                    this.type = 1;
                }
                if(tab.name == 'second'){
                    this.type = 2;
                }
            },
            playVideo(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            loadData() {
                this.$ajaxGet("/guideType/getListBySchool/"+this.type, (data) => {
                    this.tableData = data.result;
                    if(data.result.length > 0){
                        this.list = this.tableData[0].guides;
                        this.activeIndex = this.tableData[0].id+"";
                    }
                })
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            initList(id) {
                this.list = [];
                this.activeIndex = id+'';
                let currentData = this.tableData.filter(item => item.id == id)
                this.list = currentData[0].guides;
            },
        },
        created() {

            this.loadData();
        }
    }
</script>
